var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-value width-2x" },
        [
          _c("el-input", {
            attrs: { disabled: "" },
            model: {
              value: _vm.staffInfo.comName,
              callback: function($$v) {
                _vm.$set(_vm.staffInfo, "comName", $$v)
              },
              expression: "staffInfo.comName"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-value width-2x" },
        [
          _c("el-input", {
            attrs: { disabled: "" },
            model: {
              value: _vm.staffInfo.name,
              callback: function($$v) {
                _vm.$set(_vm.staffInfo, "name", $$v)
              },
              expression: "staffInfo.name"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(3),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-value width-2x" },
        [
          _c("el-input", {
            attrs: { disabled: "" },
            model: {
              value: _vm.staffInfo.phoneNo,
              callback: function($$v) {
                _vm.$set(_vm.staffInfo, "phoneNo", $$v)
              },
              expression: "staffInfo.phoneNo"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-row spacing", staticStyle: { height: "88px" } },
      [
        _vm._m(4),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-2x" },
          [
            _c("el-input", {
              staticStyle: { height: "78px" },
              attrs: { type: "textarea" },
              model: {
                value: _vm.applyDesc,
                callback: function($$v) {
                  _vm.applyDesc = $$v
                },
                expression: "applyDesc"
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [
        _c("span", { staticClass: "color-laber" }),
        _vm._v("离职人员信息")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("所属公司：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("员工名称：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("联系电话：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("申请描述：")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb30a6e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb30a6e0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/staffBiz/StaffResignFromSave.vue
// module id = 3320
// module chunks = 1